import { toast } from "react-toastify";
import moment from "moment";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    fetchExportOrdersExcel,
    orderExportHistoryGet,
    orderExportLayoutsGet,
    orderNotExportedGet
} from "./requests";
import exportFromBlob from "../../../../helpers/export-from-blob";

export const FETCH_EXPORT_ORDERS_HISTORY_SUCCESS = "FETCH_EXPORT_ORDERS_HISTORY_SUCCESS";
export const FETCH_EXPORT_ORDER_LAYOUTS_SUCCESS = "FETCH_EXPORT_ORDER_LAYOUTS_SUCCESS";
export const FETCH_NOT_EXPORTED_ORDERS_SUCCESS = "FETCH_NOT_EXPORTED_ORDERS_SUCCESS";

export const EXPORT_ORDERS_HISTORY_LOADING = "EXPORT_ORDERS_HISTORY_LOADING";
export const NOT_EXPORTED_ORDERS_REQUEST_LOADING = "NOT_EXPORTED_ORDERS_REQUEST_LOADING";
export const EXPORT_ORDERS_REQUEST_ERRORS = "EXPORT_ORDERS_REQUEST_ERRORS";


export const setHistoryLoading = (loading) => (dispatch) => dispatch({
    type: EXPORT_ORDERS_HISTORY_LOADING,
    payload: loading
});

export const setNotExportedOrdersLoading = (loading) => (dispatch) => dispatch({
    type: NOT_EXPORTED_ORDERS_REQUEST_LOADING,
    payload: loading
});

export const saveExportOrdersHistory = (data) => (dispatch) => {
    dispatch({
        type: FETCH_EXPORT_ORDERS_HISTORY_SUCCESS,
        payload: data
    });
};

export const saveNotExportedOrders = (data) => (dispatch) => {
    dispatch({
        type: FETCH_NOT_EXPORTED_ORDERS_SUCCESS,
        payload: data
    });
};
export const fetchExportOrdersHistory = ({
                                             supplierId,
                                             jobId,
                                             fromDate,
                                             toDate
                                         }) => (dispatch) => {
    dispatch(setHistoryLoading(true));
    orderExportHistoryGet(supplierId, jobId, fromDate, toDate)
        .then(response => {
            dispatch(saveExportOrdersHistory(response.data));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, EXPORT_ORDERS_REQUEST_ERRORS));
        });
};
export const fetchNotExportedOrders = ({
                                             supplierId,
                                             jobId
                                         }) => (dispatch) => {
    dispatch(setNotExportedOrdersLoading(true));
    orderNotExportedGet(supplierId, jobId)
        .then(response => {
            dispatch(saveNotExportedOrders(response.data));
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, EXPORT_ORDERS_REQUEST_ERRORS));
        });
};

export const fetchOrderExportLayouts = () => (dispatch) => {
    orderExportLayoutsGet()
        .then(response => {
            dispatch({
                type: FETCH_EXPORT_ORDER_LAYOUTS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, EXPORT_ORDERS_REQUEST_ERRORS));
        });
};

export const exportOrdersExcel = ({
                                      orderLayoutId,
                                      supplierId,
                                      data
                                  }, callback) => (dispatch) => {
    dispatch(setNotExportedOrdersLoading(true));
    fetchExportOrdersExcel(orderLayoutId, supplierId, data)
        .then(response => {
            toast("Orders exported successfully", {
                type: toast.TYPE.SUCCESS,
            });
            const fileName = decodeURI(response.headers["content-disposition"].split("''")[1]) ||
                `Orders_${moment().format("YYYY-MM-DD-HH-mm")}.xlsx`;
            exportFromBlob(response.data, fileName);
            callback();
        })
        .catch((error) => {
            dispatch(defaultErrorHandler({ }, EXPORT_ORDERS_REQUEST_ERRORS));
            toast("Invalid layout", {
                type: toast.TYPE.ERROR,
            });
        });
};
